var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Video',{ref:"videoPlayer",staticClass:"videoPlayer",attrs:{"src":_vm.videoUrl,"controls":"","autoplay":"autoplay","controlsList":'nodownload'},on:{"contextmenu":function($event){$event.preventDefault();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }